import React from 'react';
import Suite from './assets/suite2.jpg';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './nosSuites.css';

const suitesData = [
  {
    id: 'suite',
    title: 'Suite',
    description: 'Découvrez nos suites communicantes et quadruples, idéales pour les familles ou groupes, alliant confort, espace et intimité.',
    image: Suite,
    direction: -100,
    ligneClass: 'ligneHorizontaleS',
    contentClass: 'ContenuS'
  }
];

const NosSuites = () => {
  const navigate = useNavigate();

  const handleExploreClick = () => {
    navigate('/AobergeS'); // redirection vers la page Aoberge
  };

  return (
    <div className="main-section-suite" id='suite'>
      <h1>Nos Suites</h1>
      <div>
        {suitesData.map((suite) => (
          <motion.div
            key={suite.id}
            initial={{ opacity: 0, x: suite.direction }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.3 }}
            className="container-suite"
          >
            <div className="block-suite">
              <div className={suite.contentClass}>
                <img src={suite.image} alt={`Photo de ${suite.title}`} loading="lazy" />
                <div className="descriptionS">
                  <h2>{suite.title}</h2>
                  <p>{suite.description}</p>
                  <button className="buttonS" onClick={handleExploreClick}>
                    Explore More
                  </button>
                </div>
              </div>
            </div>
            <div className={suite.ligneClass}></div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NosSuites;
